import { List, Record } from 'immutable';

import { SIGN_OUT_SUCCESS } from '../auth';

import {
  REQUEST_DELETE_LOTTERIES,
  DELETE_LOTTERIES_SUCCESS,
  DELETE_LOTTERIES_ERROR,
  DELETE_LOTTERY_SUCCESS,
  CREATE_LOTTERY_SUCCESS,
  UPDATE_LOTTERY_SUCCESS,
  LOAD_LOTTERIES_SUCCESS,
  REQUEST_SELECT_WINNER,
  SELECT_WINNER_SUCCESS,
  SELECT_WINNER_ERROR,
  REQUEST_CLEAR_LOTTERIES,
  CLEAR_LOTTERIES_SUCCESS,
  CLEAR_LOTTERIES_ERROR,
  START_DRAM_ROLL,
  FINISH_DRAM_ROLL,
  FINISH_WIN_ANIMATION,
  SHOW_SNAK_BAR,
  HIDE_SNAK_BAR,
  UPDATE_NUMBER_OF_WINNER,
} from './action-types';

export const LotteriesState = new Record({
  list: new List(),
  pending: false,
  dramRoll: false,
  selectWinner: false,
  showAnimation: false,
  drumRollSound: 'PAUSED',
  winnerSound: 'PAUSED',
  message: '',
  isSnackBar: false,
  lastWinners: new List(),
  numberOfWinner: 1,
});

export function lotteriesReducer(
  state = new LotteriesState(),
  { payload, type, error },
) {
  switch (type) {
    case CREATE_LOTTERY_SUCCESS:
      return state.merge({
        list: state.list.unshift(payload),
      });

    case DELETE_LOTTERY_SUCCESS:
      return state;

    case UPDATE_LOTTERY_SUCCESS:
      return state.merge({
        list: state.list.map(
          lottery =>
            lottery.phone_number === payload.phone_number ? payload : lottery,
        ),
      });

    case LOAD_LOTTERIES_SUCCESS:
      return state.set('list', new List(payload.reverse()));

    case SIGN_OUT_SUCCESS:
      return new LotteriesState();

    case REQUEST_DELETE_LOTTERIES:
    case REQUEST_SELECT_WINNER:
    case REQUEST_CLEAR_LOTTERIES:
      return state.merge({
        pending: true,
        message: '',
      });

    case DELETE_LOTTERIES_SUCCESS:
    case DELETE_LOTTERIES_ERROR:
    case CLEAR_LOTTERIES_SUCCESS:
    case CLEAR_LOTTERIES_ERROR:
      return state.merge({
        pending: false,
        message: payload.message || error.message,
      });

    case SELECT_WINNER_SUCCESS:
      return state.merge({
        pending: false,
        winnerSound: 'PLAYING',
        message: payload.message,
        lastWinners: payload.success ? payload.maskWinners : [],
      });

    case SELECT_WINNER_ERROR:
      return state.merge({
        pending: false,
        showAnimation: false,
        message: payload.message || error.message,
        isSnackBar: true,
      });

    case START_DRAM_ROLL:
      return state.merge({
        showAnimation: true,
        pending: true,
        dramRoll: true,
        drumRollSound: 'PLAYING',
      });

    case FINISH_DRAM_ROLL:
      return state.merge({
        dramRoll: false,
        drumRollSound: 'PAUSED',
      });

    case FINISH_WIN_ANIMATION:
      return state.merge({
        showAnimation: false,
        winnerSound: 'PAUSED',
      });

    case SHOW_SNAK_BAR:
      return state.merge({
        isSnackBar: true,
        message: payload.message,
      });

    case HIDE_SNAK_BAR:
      return state.merge({
        isSnackBar: false,
      });

    case UPDATE_NUMBER_OF_WINNER:
      return state.merge({
        numberOfWinner: payload.numberOfWinner,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/core/lotteries/reducer.js